import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from '../layouts/ErrorPage';
import Dashboard from '../pages/Dashboard';
import AuthRoute from './AuthRoute';
import ProtectedRoute from './ProtectedRoute';
import GatewayMaster from '../pages/gatewayManagement';
import ComponentMaster from '../pages/ComponentMaster';
import PlatformServicesMaster from '../pages/PlatformServicesMaster';
import MachineryManagement from '../pages/MachineryManagement';
import OTAssets from '../pages/gatewayManagement/OTAssets';
import Services from '../pages/gatewayManagement/Services';
import Parameters from '../pages/gatewayManagement/Parameters';
import BuildDeployUsecase from '../pages/UseCases/buildAndDeploy';
import OntologyLevelMaster from '../pages/OntologyMaster/ontologyLevels';
import OntologyManagement from '../pages/OntologyMaster/ontologyManagement';
import PartManagement from '../pages/MachineryManagement/PartManagement';
import UserList from '../pages/UserManagement/userList';
import FactoryManagement from '../pages/FactoryManagement';
import FactoryFlow from '../pages/FactoryManagement/factoryFlow';
import UseCaseFlow from '../pages/UseCases/useCaseFlow';
import LoadingScreen from '../common/loadingScreen';
import UserAccessControl from '../pages/UserAccessControl';
import UserManagement from '../pages/UserManagement';
import UserRoleAccessControl from '../pages/UserRoleAccessControl';
import UseCaseComponent from '../pages/UseCases';
import Profile from '../pages/Profile';
import UsersManagement from '../pages/UserManagement';
import ConnectivityDashboard from '../pages/ConnectivityDashboard/connectivityDashboard';
import Settings from '../pages/Settings';
import UnityPlayer from '../pages/DigitalTwin/UnityPlayer';
import DigitalTwin from '../pages/DigitalTwin';
import NewConnectivityDashabord from '../pages/NewConnectivityDashabord';
import AssetsHistory from '../pages/NewConnectivityDashabord/assetsHistory';
import AssetsTable from '../pages/NewConnectivityDashabord/assetsTable';
import GatewaysTable from '../pages/NewConnectivityDashabord/gatewaysTable';
import InfluxTable from '../pages/NewConnectivityDashabord/influxTable';
import MqBrokerTable from '../pages/NewConnectivityDashabord/mqBrokerTable';
import SecretManger from '../pages/SecretManager';
import MaintenanceManagement from '../pages/MaintenanceManagement';
import ActivityList from '../pages/MaintenanceManagement/ActivityList/activityList';
import MaintenacePlan from '../pages/MaintenanceManagement/PlanList/maintenacePlan';
import ActivityHistory from '../pages/MaintenanceManagement/History/activityHistory';
import MaintenanceHistory from '../pages/MaintenanceManagement/History';
import CreateMaintenance from '../pages/MaintenanceManagement/PlanList/createmaintenance';
import AddEditActivity from '../pages/MaintenanceManagement/ActivityList/addEditActivity';
import MachineList from '../pages/MaintenanceManagement/MachineList/machineList';

import UseCaseBuilder from '../pages/UseCaseBuilder';
import DynamicAppLoader from '../pages/Applications/AppLoader';
import RemoteAppLoader from '../common/RemoteAppLoader';
import DashboardLoader from '../common/DashboardLoader';
import NotAuthorized from '../layouts/NotAuthorized';
// import Gpt from '../pages/Gpt';
// import EmSaver from '../pages/EmSaver';

const RouteConfig = createBrowserRouter([
  {
    element: <AuthRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <LoadingScreen />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/dashboard/:reqType',
        element: <Dashboard />,
      },
      {
        path: '/ontology',
        element: <OntologyLevelMaster />,
      },
      {
        path: '/component',
        element: <ComponentMaster />,
      },
      {
        path: '/integration',
        element: <PlatformServicesMaster />,
      },
      {
        path: '/assets/ontology',
        element: <OntologyManagement />,
      },
      {
        path: '/assets/factory-management',
        element: <FactoryManagement />,
      },
      {
        path: '/assets/factory-management/:factoryId',
        element: <FactoryFlow />,
      },
      {
        path: '/assets/factory-management/:factoryId/live',
        element: <FactoryFlow readonly={true} />,
      },
      {
        path: '/assets/machinery',
        element: <MachineryManagement />,
      },
      {
        path: '/assets/gateways',
        element: <GatewayMaster />,
      },
      {
        path: '/use-cases',
        element: <UseCaseComponent />,
        // element: <Flow />,
        // element: <h6>yet to implement</h6>,
      },
      {
        path: '/use-cases/:useCaseId',
        element: <UseCaseFlow readonly={true} />,
      },
      {
        path: '/use-cases/:useCaseId/live',
        element: <UseCaseFlow readonly={true} />,
      },
      // {
      //   path: '/use-cases/:id/live-landscapes',
      //   element: <h6>yet to implement</h6>,
      // },
      {
        path: '/user-management',
        element: <UserManagement />,
      },
      {
        path: '/assets/gateways/OTAsset',
        element: <ErrorPage />,
      },
      {
        path: '/assets/gateways/OTAsset/services',
        element: <ErrorPage />,
      },
      {
        path: '/assets/gateways/OTAsset/services/parameters',
        element: <ErrorPage />,
      },
      {
        path: '/assets/machinery/:machine_id/parts',
        element: <PartManagement />,
      },
      {
        path: 'user-management/:user_id/user-access-control',
        element: <UserAccessControl />,
      },
      {
        path: 'user-management/:role_id/user-role-access-control',
        element: <UserRoleAccessControl />,
      },
      {
        path: '/profile',
        element: <Profile />,
      },
      {
        path: '/setting',
        element: <Settings />,
      },
      {
        path: '/connectivity-dashboard',
        // element: <ConnectivityDashboard />,
        element: <NewConnectivityDashabord />,
      },
      {
        path: '/connectivity-dashboard/:level_number/:onto_id',
        element: <ConnectivityDashboard />,
      },
      {
        path: '/assets/factory-management/pending-approval/all',
        element: <FactoryManagement />,
      },
      {
        path: '/use-cases/pending-approval/all',
        element: <UseCaseComponent />,
      },
      {
        path: 'digital-twin',
        element: <DigitalTwin />,
      },
      {
        path: 'digital-twin/:dt_id/:application_mode',
        element: <UnityPlayer />,
      },
      {
        path: '/connectivity-dashboard/assethistory/:asset_id',
        element: <AssetsHistory />,
      },
      {
        path: '/connectivity-dashboard/assets/:onto_manage_id/:type',
        element: <AssetsTable />,
      },
      {
        path: '/connectivity-dashboard/assets/:onto_manage_id/:type/history/:asset_id',
        element: <AssetsHistory />,
      },
      {
        path: '/connectivity-dashboard/gateways/:onto_manage_id/:type',
        element: <GatewaysTable />,
      },
      {
        path: '/connectivity-dashboard/influx/:onto_manage_id/:type',
        element: <InfluxTable />,
      },
      {
        path: '/connectivity-dashboard/mqbroker/:onto_manage_id/:type',
        element: <MqBrokerTable />,
      },
      {
        path: '/secrets-manager',
        element: <SecretManger />,
      },
      {
        path: '/secrets-manager/:selectedTab',
        element: <SecretManger />,
      },
      {
        path: '/maintenance-management',
        element: <MaintenanceManagement />,
      },
      {
        path: '/maintenance-management/activity-list',
        element: <ActivityList />,
      },
      {
        path: '/maintenance-management/activity-list/view/:activityId',
        element: <AddEditActivity />,
      },
      {
        path: '/maintenance-management/activity-list/add',
        element: <AddEditActivity />,
      },
      {
        path: '/maintenance-management/activity-list/edit/:activityId',
        element: <AddEditActivity />,
      },

      {
        path: '/maintenance-management/history/:maintId',
        element: <MaintenanceHistory />,
      },
      {
        path: '/maintenance-management/history/:maintId/activity/:actiId',
        element: <ActivityHistory />,
      },
      {
        path: '/maintenance-management/plan-list',
        element: <MaintenacePlan />,
      },
      {
        path: '/maintenance-management/plan-list/corrective',
        element: <MaintenacePlan />,
      },

      {
        path: '/maintenance-management/plan-list/add',
        element: <CreateMaintenance />,
      },
      {
        path: '/maintenance-management/plan-list/edit/:planId',
        element: <CreateMaintenance />,
      },
      {
        path: '/maintenance-management/plan-list/view/:planId',
        element: <CreateMaintenance />,
      },
      {
        path: '/maintenance-management/machine-list',
        element: <MachineList />,
      },
      {
        path: 'custom-applications',
        element: <DynamicAppLoader />
      },
      {
        path: 'usecase-management',
        element: <UseCaseBuilder />
      },
      {
        path: 'usecase-management/grafana-templates',
        element: <UseCaseBuilder />
      },
      {
        path: '/usecase-management/pending-approval',
        element: <UseCaseBuilder />
      },
      {
        path: 'applications/:applicationName',
        element: <RemoteAppLoader />
      },
      {
        path: 'dashboards/:id',
        element: <DashboardLoader />
      },
      // {
      //   path: '/gpt',
      //   element: <Gpt />,
      // },
      // {
      //   path: '/emsaver',
      //   element: <EmSaver />,
      // },
    ],
  },
  {
    path: '/notauthorized',
    element: <NotAuthorized />,
  },
  {
    path: '*',
    element: <ErrorPage />,
  },
]);

export default RouteConfig;
